import proxybase from './proxybase';

class groupService {
  getGroupAttendant(body) {
    return proxybase
      .post(`/groups/couple-groups`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllGroups(body) {
    return proxybase
      .post(`/groups/all-couple-groups`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllGroupsByLeader(body) {
    return proxybase
      .post(`/groups/all-couple-groups-by-leaders`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getClosedGroups(body) {
    return proxybase
      .get(`/groups/closed-groups`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  saveGroupParticipant(body) {
    return proxybase
      .post(`/groups/createGroupMembers`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  attendanceRegister(body) {
    return proxybase
      .post(`/groups/register-couple-attendance`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  editGroup(body) {
    return proxybase
      .post(`/groups/edit-couple-group`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  editGroupLeaders(body) {
    return proxybase
      .post(`/groups/edit-group-leaders`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  createGroup(body) {
    return proxybase
      .post(`/groups/create-couple-group`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  complianceForms(body) {
    return proxybase
      .post(`/groups/compliance-form`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  allComplianceForms(body) {
    return proxybase
      .post(`/groups/all-compliance-forms`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  GroupMemberDelete(body) {
    return proxybase
      .post(`/groups/delete-group-member`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  GroupMemberAccept(body) {
    return proxybase
      .post(`/groups/accept-group-member`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  EditGroupMember(body) {
    return proxybase
      .post(`/groups/edit-group-member`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  PendingGroupPeople(body) {
    return proxybase
      .post(`/groups/get-pending-people`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  sendProspectLeaders(body) {
    return proxybase
      .post(`/groups/sendProspectLeaders`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getProspectLeader(body) {
    return proxybase
      .post(`/groups/getProspectLeader`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllProspectLeaders(body) {
    return proxybase
      .post(`/groups/getAllProspectLeaders`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  updateProspectLeaderForm(body) {
    return proxybase
      .post(`/groups/updateProspectLeaderForm`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  newLeaderForm(body) {
    return proxybase
      .post(`/groups/newLeaderForm`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllNewLeaders(body) {
    return proxybase
      .post(`/groups/getAllNewLeaders`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  updateNewLeaderForm(body) {
    return proxybase
      .post(`/groups/updateNewLeaderForm`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getNewLeaderByToken(body) {
    return proxybase
      .post(`/groups/getNewLeaderByToken`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  updateNewLeaderByToken(body) {
    return proxybase
      .post(`/groups/updateNewLeaderByToken`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
const groupServiceInstance = new groupService();
export default groupServiceInstance;
